import { TIME_LANG_KEY } from 'config/constants';

export function getMarkerTextKey(startTime?: number, endTime?: number) {
    const now = Math.round(Date.now() / 1000);
    let markerText = TIME_LANG_KEY.PAST;

    if (startTime && now > startTime && endTime && now < endTime) {
        markerText = TIME_LANG_KEY.NOW;
    }
    if (startTime && now < startTime) {
        markerText = TIME_LANG_KEY.FUTURE;
    }

    return markerText;
}
